import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

function PrimaryHero({
  titleId,
  icon,
  kicker,
  title,
  description,
  imageSrc,
  imageAlt = "",
  actions,
}) {
  const isDecorativeImage = imageAlt === "";

  return (
    <section className="primary-hero section-ms" aria-labelledby={titleId}>
      <div className="section-ms-inner primary-hero-inner">
        <div className="primary-hero-copy">
          <span className="brand-icon primary-hero-icon" aria-hidden="true">
            <FontAwesomeIcon icon={icon} />
          </span>
          <p className="section-ms-kicker">{kicker}</p>
          <h1 id={titleId}>{title}</h1>
          <div className="primary-hero-lede">{description}</div>
          {actions ? <div className="primary-hero-actions">{actions}</div> : null}
        </div>
        <figure
          className="hero-feature-media"
          aria-hidden={isDecorativeImage ? "true" : undefined}
        >
          <img
            src={imageSrc}
            alt={imageAlt}
            width="1067"
            height="800"
            decoding="async"
          />
        </figure>
      </div>
    </section>
  );
}

export default PrimaryHero;
